import React from "react";
import useUserStore from "../../../../../storeModules/useUserStore";
import { buildPixQrcodeImageUrl } from "../../../../../utils/buildStepStructuredItems";

const PixPaymentImage = () => {
  const { payment } = useUserStore((state) => state);
  const pix = payment?.pix ?? {};
  const pixUrl = buildPixQrcodeImageUrl(pix.qrCode, pix.url);

  if (!pixUrl) {
    return null;
  }

  return (
    <img
      style={{ width: "200px", height: "200px" }}
      src={pixUrl}
      alt="Pix QR code"
    />
  );
};

export default PixPaymentImage;
